import { render, staticRenderFns } from "./TrailVideotape.vue?vue&type=template&id=653b2d4c&scoped=true"
import script from "./TrailVideotape.vue?vue&type=script&lang=js"
export * from "./TrailVideotape.vue?vue&type=script&lang=js"
import style0 from "./TrailVideotape.vue?vue&type=style&index=0&id=653b2d4c&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b2d4c",
  null
  
)

export default component.exports